





































































































































import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import Vue from 'vue';
import i18n from '@/web/utils/localization';
import HMDialog from '@/web/components/common/HMDialog.vue';
import { mapGetters } from 'vuex';
import { notify } from '@/web/utils/notify';
import store from '@/core/store';

export default Vue.extend({
  name: 'Pages',
  components: {
    TopNav,
    NavItem,
  },
  data() {
    return {
      search: '',
      status: null,
      statuses: [
        { label: i18n.t('PAGES.LABEL.PUBLISHED'), code: 'published' },
        { label: i18n.t('PAGES.LABEL.DRAFT'), code: 'unpublished' },
      ],
      tableFields: [
        {
          name: 'title',
          title: this.$t('PAGES.TABLE.PAGE_TITLE') as string,
        },
        {
          name: 'slug',
          title: this.$t('PAGES.TABLE.PAGE_URL') as string,
          cssClass: 'h6 m-0',
        },
        {
          cssClass: 'p-0 align-items-center',
          name: 'status',
          title: this.$t('PAGES.TABLE.STATUS') as string,
        },
        {
          name: 'settings',
          shrink: true,
          cssClass: 'p-0',
          disableClick: true,
        },
        {
          name: 'edit',
          shrink: true,
          cssClass: 'p-0',
          disableClick: true,
        },
        {
          name: 'options',
          shrink: true,
          cssClass: 'p-0',
          disableClick: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      teacherStudioUrl: 'user/teacherStudioUrl',
      pagesLocationUrl: 'setting/pagesLocationUrl',
      pageGenerated: 'websocket/pageGenerated',
    }),
    query(): {} {
      return {
        q: this.search,
        status: this.status?.code,
      };
    },
  },
  methods: {
    refreshTable() {
      this.$refs['pages-table']?.refresh();
    },
    settings(id) {
      this.$router.push({
        name: 'edit-page',
        params: { id },
      });
    },
    preview(page) {
      window.open(`${this.pagesLocationUrl}/${page.slug}`, '_blank');
    },
    async unpublish(id) {
      await this.$store.dispatch('page/publishPage', id);
      this.refreshTable();
    },
    async publish(id) {
      await this.$store.dispatch('page/unpublishPage', id);
      this.refreshTable();
    },
    async duplicate(id) {
      await this.$store.dispatch('page/duplicatePage', id);
      this.refreshTable();
    },
    async setAsHomePage(id) {
      await this.$store.dispatch('page/setAsHomePage', id);
      this.refreshTable();
    },
    async removeAsHomePage(page) {
      await this.$store.dispatch('page/removeAsHomePage', page);
      this.refreshTable();
    },
    isProcessing(page) {
      return page.status === 'processing';
    },
    isError(page) {
      return page.status === 'error';
    },
    isProcessingOrError(page) {
      return this.isProcessing(page) || this.isError(page);
    },
    async deletePage(id) {
      const title = this.$t('PAGES.TITLE.DELETE_PAGE');
      const text = this.$t('PAGES.TEXT.DELETE_PAGE_DESCRIPTION');
      const confirm = async () => {
        await this.$store.dispatch('page/deletePage', id);
        this.refreshTable();
      };
      const discard = () => {};

      this.$modal.show(HMDialog, {
        title,
        text,
        confirm,
        discard,
      });
    },
    getStatusText(status) {
      const statusKeys = {
        error: this.$t('PAGES.LABEL.ERROR'),
        processing: this.$t('PAGES.LABEL.PROCESSING'),
        published: this.$t('PAGES.LABEL.PUBLISHED'),
        unpublished: this.$t('PAGES.LABEL.DRAFT'),
      };

      return statusKeys[status];
    },
    copyPagesUrlToClipboard(pageSlug) {
      const pageUrl = `${this.pagesLocationUrl}/${pageSlug}`;
      this.$copyText(pageUrl).then(() => {
        notify(this.$t('NOTIFICATIONS.TEXT.COPIED') as string, pageUrl);
      });
    },
  },
  mounted() {
    this.$store.dispatch('setting/getPagesDomain');
  },
  watch: {
    pageGenerated: {
      handler: function (pageGenerated) {
        console.log('pageGenerated', pageGenerated);
        if (!pageGenerated) return;
        if (this.teacherStudioUrl === pageGenerated.studio_url) {
          this.refreshTable();
        }
      },
    },
    $route: {
      handler: function () {
        this.refreshTable();
      },
    },
  },
});
